import { createFileRoute } from "@tanstack/react-router";
import { ArticlePage } from "@/components/ArticlePage";
import { articleSchemas, qaSchema } from "@/lib/seo";

const UPDATED = "2026-10-14";
const ANSWER = "Kunden in Deutschland erwarten meist PayPal, Kreditkarte, Apple Pay oder Google Pay und Kauf auf Rechnung. In der Schweiz kommt TWINT dazu, in Österreich ist Sofortüberweisung verbreitet. Fehlt die gewohnte Zahlungsart, brechen viele den Kauf ab.";
const SITE = "https://shopify-freelancer.net";
const PATH = "/fragen/shopify-zahlungsarten";
const TITLE = "Welche Zahlungsarten brauche ich in meinem Shopify-Shop?";
const DESCRIPTION = "Shopify Zahlungsarten für Deutschland, Österreich und die Schweiz: welche Ihre Kunden erwarten und wie sie Abbrüche an der Kasse senken.";

const faqs = [
  { q: "Brauche ich Kauf auf Rechnung?", a: "Für viele Zielgruppen ja. Im B2B ist es fast Pflicht." },
  { q: "Wie viele Zahlungsarten sind sinnvoll?", a: "Lieber vier passende als zehn unbekannte. Zu viele Logos verwirren eher." },
  { q: "Kann ich Zahlungsarten nachträglich ergänzen?", a: "Ja, das geht jederzeit über die Einstellungen oder eine Zahlungs-App." },
];

export const Route = createFileRoute("/fragen/shopify-zahlungsarten")({
  component: Page,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      ...articleSchemas({ title: TITLE, description: DESCRIPTION, path: PATH, faqs, section: "Shopify Zahlungsarten", updated: UPDATED, breadcrumb: { name: "Fragen", path: "/fragen" } }),
      qaSchema({ question: TITLE, answer: ANSWER, path: PATH, updated: UPDATED }),
    ],
  }),
});

function Page() {
  return (
    <ArticlePage
      kicker="Frage · Zahlung"
      title={TITLE}
      intro="Kurz gesagt: Bieten Sie an, was Ihre Kunden gewohnt sind. Jede fehlende Zahlungsart kostet Bestellungen an der Kasse."
      source="frage-shopify-zahlungsarten"
      answer={ANSWER}
      updated={UPDATED}
      breadcrumb={{ to: "/fragen", label: "Fragen" }}
      sections={[
        { h: "Die wichtigsten Zahlungsarten", p: [], list: ["PayPal: in Deutschland sehr verbreitet", "Kreditkarte, Apple Pay und Google Pay: schnell, besonders mobil", "Kauf auf Rechnung: wichtig für viele Käufer und für B2B", "TWINT für die Schweiz"] },
        { h: "Weniger Abbrüche an der Kasse", p: ["Zeigen Sie die Zahlungsarten schon auf der Produktseite. Wer früh sieht, dass seine Lieblingszahlungsart dabei ist, kauft eher."] },
        { h: "Gebühren im Blick behalten", p: ["Jede Zahlungsart hat eigene Gebühren. Es lohnt sich, die Kosten mit den tatsächlich genutzten Zahlungsarten abzugleichen."] },
      ]}
      faqs={faqs}
      related={[{ to: "/fragen/warum-kauft-niemand-in-meinem-shop", label: "Warum kauft niemand?" }, { to: "/shopify-conversion-optimierung", label: "Conversion-Optimierung" }, { to: "/fragen/shopify-gebuehren", label: "Shopify Gebühren" }]}
    />
  );
}
